import "./Nav.scss";
import { useContext } from "react";
import { LangContext } from "../../context/langContext";
import { Link, useLocation, useNavigate } from "react-router-dom";
import appStoreBadge from "../../assets/app-store-badge.webp";
import appStoreBadgeEn from "../../assets/app-store-badge-en.webp";
import googlePlayBadge from "../../assets/google-play-badge.webp";
import googlePlayBadgeEn from "../../assets/google-play-badge-en.webp";
import LangSelect from "../LangSelect/LangSelect";

const Nav = ({ textData, isMobile, toggleNav, isNavActive, changeLang }) => {
  const lang = useContext(LangContext);
  const location = useLocation();
  const navigate = useNavigate();

  if (!isMobile) {
    return (
      <nav className="nav">
        <Link to="/help/privacy" className="nav__link">
          {textData[lang].header.privacy}
        </Link>
        <Link to="/help/terms" className="nav__link">
          {textData[lang].header.rules}
        </Link>
        <a
          href="#about"
          className="nav__link"
          onClick={() => {
            return location.pathname === "/" ? null : navigate("/");
          }}
        >
          {textData[lang].header.about}
        </a>
      </nav>
    );
  }
  return (
    <div
      className={`nav-mobile-wrapper ${
        isNavActive && "nav-mobile-wrapper_active"
      }`}
    >
      <nav className="nav-mobile">
        <Link to="/help/privacy" className="nav__link" onClick={toggleNav}>
          {textData[lang].header.privacy}
        </Link>
        <Link to="/help/terms" className="nav__link" onClick={toggleNav}>
          {textData[lang].header.rules}
        </Link>
        <a
          href="#about"
          className="nav__link"
          onClick={() => {
            toggleNav();
            return location.pathname === "/" ? null : navigate("/");
          }}
        >
          {textData[lang].header.about}
        </a>
      </nav>
      <div className="nav__download-links">
        <a
          href="https://apps.apple.com/kz/app/totem-chat/id6444722452"
          className="download-links__item"
        >
          <img
            src={lang === "RU" ? appStoreBadge : appStoreBadgeEn}
            alt="app store"
            className="download-links__icon"
          />
        </a>
        <a
          href="https://play.google.com/store/apps/details?id=kz.mobile.totemchat&hl=ru&gl=US"
          className="download-links__item"
        >
          <img
            src={lang === "RU" ? googlePlayBadge : googlePlayBadgeEn}
            alt="google play"
            className="download-links__icon"
          />
        </a>
      </div>
      <LangSelect changeLang={changeLang} />
    </div>
  );
};

export default Nav;
